import { useTranslation } from 'react-i18next'

import {
    bill100,
    bill200,
    bill500,
    bill1000,
    bill2000,
    bill5000,
    insertCashImg
} from '@/assets/images'
import { useOrder } from '@/providers'

const AcceptedBills = () => {
    const { t } = useTranslation()
    const {
        state: { voucherType }
    } = useOrder()

    return (
        <div className="accepted-bills">
            <div className="accepted-bills__content">
                <div className="accepted-bills__left">
                    <h2>{t('acceptedBills.title')}:</h2>
                    {voucherType?.toString() === 'betting' ? (
                        <div className="bills bills--betting">
                            <img src={bill500} alt="500 RSD" />
                            <img src={bill1000} alt="1000 RSD" />
                            <img src={bill2000} alt="2000 RSD" />
                            <img src={bill5000} alt="5000 RSD" />
                        </div>
                    ) : (
                        <div className="bills bills--gaming">
                            <img src={bill100} alt="100 RSD" />
                            <img src={bill1000} alt="1000 RSD" />
                            <img src={bill200} alt="200 RSD" />
                            <img src={bill2000} alt="2000 RSD" />
                            <img src={bill500} alt="500 RSD" />
                            <img src={bill5000} alt="5000 RSD" />
                        </div>
                    )}
                </div>
                <div className="accepted-bills__right">
                    <img src={insertCashImg} alt={t('insertCash.altText')} />
                </div>
            </div>
            <div className="info-box">
                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M30 7.5L52.5 50H7.5L30 7.5Z" stroke="#DC2626" strokeWidth="3.42857" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M30 25V35" stroke="#2D2D2D" strokeWidth="3.42857" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M30 42.5V42.5132" stroke="#2D2D2D" strokeWidth="3.42857" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span
                    dangerouslySetInnerHTML={{
                        __html: t('acceptedBills.noChangeWarning')
                    }}></span>
            </div>
        </div>
    )
}

export default AcceptedBills
